var map = {
	"./admin.mohe.life.mp4": 963,
	"./app.mohe.store.mp4": 680,
	"./chat-admin.aicess.ai.mp4": 264,
	"./chat.aicess.ai.mp4": 417,
	"./mohe.life.mp4": 733,
	"./oceanbit-admin.hyemin.kr.mp4": 793,
	"./oceanbit.hyemin.kr.mp4": 285,
	"./offie.mohe.store.mp4": 415,
	"./philodata.io.mp4": 758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 403;